// API Configuration
// Use deployed backend for production and mobile testing
export const API_BASE_URL = 'https://home-ease-backend.onrender.com';

// For local development only (uncomment below and comment above)
//export const API_BASE_URL = 'http://localhost:5000';

console.log('🔗 API Base URL:', API_BASE_URL);

export default API_BASE_URL;
